import { Component } from '@angular/core';

@Component({
		selector: 'clearcals-web-stories-layout',
		template: `<router-outlet></router-outlet>`,
})
export class WebStoriesLayoutComponent { }
